import store from "@/store";
import { ROLES } from "@/config/permissions";

function dashboardGuard(to, from, next) {
  const user = store.state.users?.user || store.getters["users/currentUser"];
  const role = store.state.users?.role || store.getters["users/currentUserRole"];

  if (!user || Object.keys(user).length === 0) {
    return next({ path: "/login", replace: true });
  }

  if (user.school && !user.hod && !user.teacher) {
    return next();
  }

  if (role === ROLES.SYSTEMADMINS || (user.role && user.role.id == 1)) {
    const intendedRoute = {
      path: to.path,
      query: to.query,
      params: to.params,
      name: to.name,
    };

    store.commit("users/setIntendedRoute", intendedRoute);
    return next({ path: "/super-admin/schools", replace: true });
  }

  return next({ path: "/landing", replace: true });
}

export default dashboardGuard;
